/**
 * @generated SignedSource<<d6b487ab3785188cc2aad98b54da30b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postiesArticleSpeechInlineWidgetPostiesArticle$data = {
  readonly articleSpeeches: ReadonlyArray<{
    readonly country: string | null | undefined;
    readonly gender: string | null | undefined;
    readonly url: string;
    readonly voiceName: string;
  } | null | undefined> | null | undefined;
  readonly entityId: string;
  readonly headline: string | null | undefined;
  readonly images: ReadonlyArray<{
    readonly isSlideshow: boolean | null | undefined;
    readonly url: string;
  } | null | undefined> | null | undefined;
  readonly socialHeadline: string | null | undefined;
  readonly " $fragmentType": "postiesArticleSpeechInlineWidgetPostiesArticle";
};
export type postiesArticleSpeechInlineWidgetPostiesArticle$key = {
  readonly " $data"?: postiesArticleSpeechInlineWidgetPostiesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"postiesArticleSpeechInlineWidgetPostiesArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "postiesArticleSpeechInlineWidgetPostiesArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "socialHeadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleSpeech",
      "kind": "LinkedField",
      "name": "articleSpeeches",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gender",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "voiceName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSlideshow",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "8e0965730aa4f8b64e48b6e8b5dfa970";

export default node;
